import { render, staticRenderFns } from "./dayHot.vue?vue&type=template&id=79a9064f&scoped=true"
import script from "./dayHot.vue?vue&type=script&lang=js"
export * from "./dayHot.vue?vue&type=script&lang=js"
import style0 from "./dayHot.vue?vue&type=style&index=0&id=79a9064f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79a9064f",
  null
  
)

export default component.exports